var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"0.33664028464766926"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from "@sentry/nextjs";

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN ||
  "https://b10629fc49f440f1a209994d69f3fe04@sentry.egwwritings.org/11";

Sentry.init({
  dsn: SENTRY_DSN,
  autoSessionTracking: false,
});
